export const exportDocumentsUrl = 'exportDocuments';
export const signedUrlDocumentsUrl = 'signedUrl';
// export type ExportDocumentType = 'adhesion' | 'honorabilite';
export enum ExportDocumentType {
  ADHESION = 'adhesion',
  HONORABILITE = 'honorabilite',
}
